/**
 * @file This configuration file defines the environment-specific settings used throughout the application.
 */

/**
 * An object containing configuration settings for different deployment environments.
 * Each environment (development, production) has specific settings for Heap Analytics, Auth0 and the API.
 * The production environment is further divided into sub-environments (test, staging, live),
 * each with its own subdomain and corresponding settings.
 */
export const environments = {
    development: {
        HEAP_APP_ID: process.env.REACT_APP_HEAP_DEV_ID,
        AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID_TEST,
        AUTH0_LOGIN_REDIRECT_URI: 'http://localhost:3000/app',
        AUTH0_LOGIN_AUDIENCE: `https://${process.env.REACT_APP_TEST_SUBDOMAIN}.${process.env.REACT_APP_PRIMARY_DOMAIN}`,
        DOMAIN: process.env.REACT_APP_PRIMARY_DOMAIN,
        SUBDOMAIN: process.env.REACT_APP_TEST_SUBDOMAIN
    },
    production: {
        test: {
            HEAP_APP_ID: process.env.REACT_APP_HEAP_DEV_ID,
            DOMAIN: process.env.REACT_APP_PRIMARY_DOMAIN,
            SUBDOMAIN: process.env.REACT_APP_TEST_SUBDOMAIN,
            AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID_TEST,
            AUTH0_LOGIN_REDIRECT_URI: `https://${process.env.REACT_APP_TEST_SUBDOMAIN}.${process.env.REACT_APP_PRIMARY_DOMAIN}/app`,
            AUTH0_LOGIN_AUDIENCE: `https://${process.env.REACT_APP_TEST_SUBDOMAIN}.${process.env.REACT_APP_PRIMARY_DOMAIN}`,
            API_KEY: process.env.REACT_APP_TEST_API_KEY
        },
        staging: {
            HEAP_APP_ID: process.env.REACT_APP_HEAP_DEV_ID,
            DOMAIN: process.env.REACT_APP_PRIMARY_DOMAIN,
            SUBDOMAIN: process.env.REACT_APP_STAGING_SUBDOMAIN,
            AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID_STAGING,
            AUTH0_LOGIN_REDIRECT_URI: `https://${process.env.REACT_APP_STAGING_SUBDOMAIN}.${process.env.REACT_APP_PRIMARY_DOMAIN}/app`,
            AUTH0_LOGIN_AUDIENCE: `https://${process.env.REACT_APP_STAGING_SUBDOMAIN}.${process.env.REACT_APP_PRIMARY_DOMAIN}`
        },
        live: {
            HEAP_APP_ID: process.env.REACT_APP_HEAP_PROD_ID,
            DOMAIN: process.env.REACT_APP_LIVE_DOMAIN,
            SUBDOMAIN: process.env.REACT_APP_LIVE_SUBDOMAIN,
            AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID_LIVE,
            AUTH0_LOGIN_REDIRECT_URI: 'https://--subdomain--.--domain--/app',
            AUTH0_LOGIN_AUDIENCE: `https://${process.env.REACT_APP_PRIMARY_SUBDOMAIN}.${process.env.REACT_APP_PRIMARY_DOMAIN}`
        }
    }
};
